import React, { useEffect, useState } from "react";
import "../styles/Home.css";
import cancelImg from "../assets/cont.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { rememberFormContact } from "../lib/cookieConsent";
import useContactPrefill from "../lib/useContactPrefill";

export default function ContactUs() {
  const { seed, filled } = useContactPrefill();
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  // Seed the fields once we know what (if anything) to pre-fill. Running on
  // `seed` also covers the case where a visitor accepts cookies after the page
  // has already loaded.
  useEffect(() => {
    setForm((f) => ({
      ...f,
      name: seed.name,
      email: seed.email,
      phone: seed.phone,
    }));
  }, [seed]);

  const update = (key) => (e) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Please enter your name and email.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    // Remember contact details for next time — a safe no-op unless the visitor
    // accepted the "Simplified Forms" cookie category.
    rememberFormContact({
      name: form.name,
      email: form.email,
      phone: form.phone,
    });
    toast.success("Thanks! Your message has been received.", {
      position: "top-right",
      autoClose: 3000,
    });
    // Keep the contact details on screen, clear only the message.
    setForm((f) => ({ ...f, message: "" }));
  };

  return (
    <div>
      <ToastContainer />
      <section
        className="cancel-wrapper"
        style={{ marginLeft: "32px", marginRight: "32px" }}
      >
        <div className="cancel-container">
          <div className="cancel-left">
            <h2
              className="contact1"
              style={{ fontSize: "2.5rem", color: "#39512f" }}
            >
              Contact Us
            </h2>
            <p
              className="contact1"
              style={{ fontSize: "15px", marginTop: "40px" }}
            >
              We'd love to hear from you! Whether you have a question about our
              menu, need assistance with an order, or just want to provide
              feedback, our team is ready to help.
            </p>
          </div>
        </div>
        <div className="cancel-container" style={{ marginTop: "30px" }}>
          <div className="cancel-left">
            {/* <h2>Cancellation and Refund</h2> */}
            <div className="h2o">
              <svg
                class="colorable-icon"
                aria-hidden="true"
                data-prefix="fal"
                data-icon="phone"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                overflow="visible"
                width={40}
                height={40}
              >
                <path
                  className="svg1"
                  fill="currentColor"
                  d="M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64v0C0 300.7 183.5 494.5 416 510.9c4.5 .3 9.1 .6 13.7 .8c0 0 0 0 0 0c0 0 0 0 .1 0c6.1 .2 12.1 .4 18.3 .4l0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM447.7 480C218.1 479.8 32 293.7 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0-3.8 2.6-7 6.3-7.8l112-24c3.7-.8 7.5 1.2 9 4.7l48 112c1.4 3.3 .5 7.1-2.3 9.3l-40.6 33.2c-12.1 9.9-15.3 27.2-7.4 40.8c29.5 50.9 71.9 93.3 122.7 122.7c13.6 7.9 30.9 4.7 40.8-7.4l33.2-40.6c2.3-2.8 6.1-3.7 9.3-2.3l112 48c3.5 1.5 5.5 5.3 4.7 9l-24 112c-.8 3.7-4.1 6.3-7.8 6.3c-.1 0-.2 0-.3 0z"
                ></path>
              </svg>
            </div>
            <p className="mt-4 int h2o" style={{ fontSize: "19px" }}>
              Call or WhatsApp
            </p>
            <p
              className="contact1"
              style={{ fontWeight: 400, fontSize: "14px" }}
            >
              Reach us directly for immediate assistance or order inquiries.
            </p>
            <p
              className="h2o"
              style={{
                fontSize: "14px",
                fontWeight: 600,
                letterSpacing: "0.6px",
              }}
            >
              077220 06638
            </p>
            <div className="h2o">
              <svg
                class="colorable-icon mt-4"
                aria-hidden="true"
                data-prefix="fal"
                data-icon="envelope"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                overflow="visible"
                width={40}
                height={40}
              >
                <path
                  fill="currentColor"
                  d="M64 96c-17.7 0-32 14.3-32 32v39.9L227.6 311.3c16.9 12.4 39.9 12.4 56.8 0L480 167.9V128c0-17.7-14.3-32-32-32H64zM32 207.6V384c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V207.6L303.3 337.1c-28.2 20.6-66.5 20.6-94.6 0L32 207.6zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
                ></path>
              </svg>
            </div>
            <p className="mt-4 int h2o" style={{ fontSize: "19px" }}>
              Email Us
            </p>
            <p
              className="contact1"
              style={{ fontWeight: 400, fontSize: "14px" }}
            >
              For detailed queries, feedback, or partnership opportunities.
            </p>
            <p
              className="h2o"
              style={{
                fontSize: "14px",
                fontWeight: 600,
                letterSpacing: "0.6px",
              }}
            >
              alfasouthin@gmail.com
            </p>
            <div className="h2o">
              <svg
                class="colorable-icon mt-4"
                aria-hidden="true"
                data-prefix="fal"
                data-icon="location-dot"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
                overflow="visible"
                height={40}
                width={40}
              >
                <path
                  fill="currentColor"
                  d="M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"
                ></path>
              </svg>
            </div>
            <p className="mt-4 int h2o" style={{ fontSize: "19px" }}>
              Visit Our Cafe
            </p>
            <p
              className="contact1"
              style={{ fontWeight: 400, fontSize: "14px", lineHeight: "20px" }}
            >
              Experience our authentic South Indian cuisine in a welcoming{" "}
              ambiance.
            </p>
            <p
              className="contact1"
              style={{
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              Shop No 3 & 4, Florina Estate, Silver Oak Society, Kalyani Nagar,
              <br /> Pune, Maharashtra 411014
            </p>
          </div>

          <div className="cancel-right">
            <img
              src={cancelImg}
              alt="Cancellation Refund"
              className="cancel-img"
            />
            <p>Our friendly team is always ready to assist you!</p>

            <form className="contact-form" onSubmit={handleSubmit}>
              <h3 className="contact-form-title">Send Us a Message</h3>
              {filled && (
                <p className="contact-form-welcome">
                  Welcome back! We've pre-filled your details for you.
                </p>
              )}
              <input
                type="text"
                className="contact-input"
                placeholder="Your Name"
                value={form.name}
                onChange={update("name")}
              />
              <input
                type="email"
                className="contact-input"
                placeholder="Your Email"
                value={form.email}
                onChange={update("email")}
              />
              <input
                type="tel"
                className="contact-input"
                placeholder="Phone Number"
                value={form.phone}
                onChange={update("phone")}
              />
              <textarea
                className="contact-input contact-textarea"
                placeholder="Your Message"
                rows={4}
                value={form.message}
                onChange={update("message")}
              />
              <button type="submit" className="contact-submit-btn">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
